import { AbstractMesh } from '@babylonjs/core/Meshes/abstractMesh';
import { Mesh } from '@babylonjs/core/Meshes/mesh';
import { Scene } from '@babylonjs/core/scene';
import { OBJExport } from '@babylonjs/serializers/OBJ';
import { getByDynamicId } from '@kb3d/models/classes/kb3d-manager';
import { MeshNode } from '@kb3d/models/classes/meshes/mesh-node';
import { RendererManager } from '@kb3d/view/render/renderer-manager';

export class ObjKb3dExporter {
    constructor(private scene: Scene, private rendererManager: RendererManager) {}

    /** generates the current scene into a glb file and returns an object url for it */
    public generateObj(meshNode?: MeshNode): string | null {
        let meshes: Mesh[];
        if (!meshNode) {
            meshes = this.scene.meshes.filter(this.shouldExportMesh);
        } else {
            const mesh = this.rendererManager.mesh.get3d(meshNode);
            if (mesh && mesh instanceof Mesh) {
                meshes = [mesh];
            } else {
                return null;
            }
        }
        return OBJExport.OBJ(meshes, false, undefined, meshes.length > 1);
    }

    public exportObj(filename = 'scene', meshNode?: MeshNode) {
        const objData = this.generateObj(meshNode);
        if (objData) {
            const blob = this.createObjBlob(objData);
            const link = document.createElement('a');
            document.body.appendChild(link);
            link.setAttribute('type', 'hidden');
            link.download = `${filename}.obj`;
            link.href = window.URL.createObjectURL(blob);
            link.click();
            setTimeout(() => {
                window.URL.revokeObjectURL(link.href);
                link.remove();
            });
        }
    }

    protected shouldExportMesh(mesh: AbstractMesh): mesh is Mesh {
        return mesh instanceof Mesh && mesh.isVisible && mesh.isEnabled() && !!getByDynamicId(mesh.id);
    }

    protected createObjBlob(objData: string) {
        const mimeType = { type: 'text/plain' };
        return new Blob([objData], mimeType);
    }
}
